module.exports = "<!--<a routerLink=\"/login\" routerLinkActive=\"active\">Login</a>-->\n<router-outlet fxLayout=\"column\" fxLayoutAlign=\"center\"  fxFlex=\"100\"></router-outlet>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 0